export default "__VITE_ASSET__BjVQT3bu__"